export const UserRole = {
  SUPERADMIN: "superadmin",
  PM: "pm",
  SE: "se",
  ENGINEER: "engineer",
  FINANCE: "finance",
  CLIENT_VIEWER: "client_viewer",
  CLIENT_DECISION_MAKER: "client_decision_maker",
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

/** Internal staff roles that see the full sidebar shell */
export const INTERNAL_ROLES: UserRole[] = [
  UserRole.SUPERADMIN,
  UserRole.PM,
  UserRole.SE,
  UserRole.FINANCE,
];

/** Client-facing portal roles */
export const CLIENT_ROLES: UserRole[] = [
  UserRole.CLIENT_VIEWER,
  UserRole.CLIENT_DECISION_MAKER,
];

/**
 * Human-readable labels for each role (English).
 * Later, replace values with translation keys when i18n is introduced.
 */
export const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.SUPERADMIN]: "Super Admin",
  [UserRole.PM]: "Project Manager",
  [UserRole.SE]: "Site Engineer",
  [UserRole.ENGINEER]: "Engineer",
  [UserRole.FINANCE]: "Finance",
  [UserRole.CLIENT_VIEWER]: "Client Viewer",
  [UserRole.CLIENT_DECISION_MAKER]: "Client Decision Maker",
} as const;

export type User = {
  id: string;
  email: string;
  fullName: string;
  role: UserRole;
  language: string;
  deleted_at?: string | null;
  createdAt?: Date;
  updatedAt?: Date;
};
